export const DEFAULT_AVATARS=[
  { img: 'images/avatar1.png', url: 'https://storageapi.fleek.co/uu-z-team-bucket/0356cf96-cb91-42dd-a1d5-3f3983321fd9' },
  { img: 'images/avatar2.png', url: 'https://storageapi.fleek.co/uu-z-team-bucket/594027e6-e6f3-4c4d-bf53-68765accbf59' },
  { img: 'images/avatar3.png', url: 'https://storageapi.fleek.co/uu-z-team-bucket/b11a73cf-b964-47fa-8339-635fcde70771' },
  { img: 'images/avatar4.png', url: 'https://storageapi.fleek.co/uu-z-team-bucket/81eb54c6-c87f-4470-aa2b-14dfa3fc3170' },
  { img: 'images/avatar5.png', url: 'https://storageapi.fleek.co/uu-z-team-bucket/2fdcc6f5-b4df-42f4-b6d1-00be4dc2c457' },
  // { img: 'images/avatar6.png', url: 'https://storageapi.fleek.co/uu-z-team-bucket/2a992823-4edb-4d94-a85d-c48072645456' },
]
